import React from 'react';
import PropTypes from 'prop-types';

import InfoSelectField from 'ntnu-react/material/InfoSelectField';
import InfoTextField from 'ntnu-react/material/InfoTextField';
import MenuItem from 'material-ui/MenuItem';


import info from '../constants/infotexts.json';
import required from '../constants/required.json';

class RequiredTab extends React.Component {
    shouldComponentUpdate(nextProps) {
        const old = this.props.data;
        const next = nextProps.data;

        return old.Required1 !== next.Required1
        || old.P_Reason !== next.P_Reason;
    }

    handleSelectChange = (field) => {
        return (e, index, value) => {
            this.props.fieldChange(field, value, true);
        };
    }

    handleTextChange = (field, recalc) => {
        return (e) => {
            this.props.fieldChange(field, e.target.value, false);
        };
    }

    render() {
        const { data } = this.props;
        return (
            <section>
                <InfoSelectField
                    floatingLabelText="Må aktiviteten gjøres?"
                    infoText={info.required.Required1}
                    value={data.Required1}
                    onChange={this.handleSelectChange('Required1')}
                    disabled={this.props.disabled}
                >
                    {required.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Required1 === item.key}
                        />
                    ))}
                </InfoSelectField>
                <InfoTextField
                    floatingLabelText="Kort begrunnelse"
                    infoText={info.required.Reason}
                    value={data.P_Reason}
                    fullWidth={true}
                    onChange={this.handleTextChange('P_Reason')}
                    multiLine={true}
                    rows={4}
                    required={true}
                    disabled={this.props.disabled}
                />
            </section>
        );
    }
}

RequiredTab.propTypes = {
    data: PropTypes.object.isRequired,
    fieldChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default RequiredTab;



// WEBPACK FOOTER //
// ./src/components/RequiredTab.js